import { useState } from 'react';
import { Avatar, Checkbox } from 'antd';
import styled from 'styled-components';
import { CredusText, CredusDropDown, color } from 'ui';
import { AiOutlineUser } from 'react-icons/ai';
import { HiOutlineDotsHorizontal } from 'react-icons/hi';

import CandidateDataModal from '../modals/CandidateDataModal';
import { CandidateData } from '../../../../../contexts/CandidateContext';

export interface TagProps {
  background: string;
  pad: string;
  radius?: string;
}

interface CandidateTableProps {
  candidates: Array<CandidateData>;
}

const CandidateDataTable = ({ candidates }: CandidateTableProps) => {
  const [candidate, setCandidate] = useState<CandidateData>();
  const [active, setActive] = useState(0);
  const [showDropDown, setShowDropDown] = useState(false);
  const [showData, setShowData] = useState(false);

  const handleDropDown = (index: number) => {
    setShowDropDown((prev) => !prev);
    setActive(index);
  };

  const handleView = (candidate: CandidateData) => {
    setCandidate(candidate);
    setShowData(true);
    setShowDropDown(false);
  };

  return (
    <div>
      {showData && candidate && (
        <CandidateDataModal
          showData={showData}
          setShowData={setShowData}
          candidate={candidate}
        />
      )}
      <Table>
        <tr>
          <Th>
            <Checkbox />
          </Th>
          <Th>
            <CredusText size="md">Candidate Name</CredusText>
          </Th>
          <Th>
            <CredusText size="md">Email</CredusText>
          </Th>
          <Th>
            <CredusText size="md">Candidate ID</CredusText>
          </Th>
          <Th>
            <CredusText size="md">Exam Category</CredusText>
          </Th>
          <Th>
            <CredusText size="md">Test Code</CredusText>
          </Th>
          <Th>
            <CredusText size="md">Status</CredusText>
          </Th>
          <Th>
            <CredusText size="md">Action</CredusText>
          </Th>
        </tr>
        {candidates?.map((candidate: CandidateData, index: number) => {
          const {
            surname,
            firstName,
            pictureUrl,
            email,
            category,
            registeredCourse,
            status,
            candidateNumber,
          } = candidate;
          return (
            <tr>
              <Td>
                <div style={{ textAlign: 'center' }}>
                  <Checkbox />
                </div>
              </Td>
              <Td>
                <CredusText size="sm">
                  <NameDiv>
                    {pictureUrl ? (
                      <Avatar src={pictureUrl} />
                    ) : (
                      <Avatar icon={<AiOutlineUser />} />
                    )}
                    <CredusText size="sm">
                      {surname} {firstName}
                    </CredusText>
                  </NameDiv>
                </CredusText>
              </Td>
              <Td>
                <CredusText size="sm">{email}</CredusText>
              </Td>
              <Td>
                <CredusText size="sm">{candidateNumber}</CredusText>
              </Td>
              <Td>
                <CredusText size="sm">{category}</CredusText>
              </Td>
              <Td>
                <Tag background="#EEEEEE" radius="30px" pad="5px">
                  <CredusText size="xs">{registeredCourse}</CredusText>
                </Tag>
              </Td>
              <Td>
                <Tag background="#FDC453" radius="5px" pad="10px">
                  <CredusText size="sm" color={color.white}>
                    {status}
                  </CredusText>
                </Tag>
              </Td>
              <Td>
                <Div>
                  <HiOutlineDotsHorizontal
                    color="#ABABAB"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleDropDown(index)}
                  />
                  {showDropDown && index == active && (
                    <CredusDropDown
                      items={[
                        <CredusText
                          size="xs"
                          onClick={() => handleView(candidate)}
                        >
                          View
                        </CredusText>,
                        <CredusText size="xs">Send Invite</CredusText>,
                        <CredusText size="xs">Delete</CredusText>,
                      ]}
                      width={'100px'}
                    />
                  )}
                </Div>
              </Td>
            </tr>
          );
        })}
      </Table>
    </div>
  );
};

export default CandidateDataTable;

const Table = styled.table`
  width: 100%;
`;

const Th = styled.th`
  background: #ffeae7;
  padding: 1rem 1.2rem;
  min-width: 44px;
`;
const Td = styled.td`
  /* background: #fbfbfb; */
  padding: 1rem 1.2rem;
  min-width: 44px;
`;

const Div = styled.div`
  position: relative;
`;

export const Tag = styled.div<TagProps>`
  background: ${(props) => props.background};
  padding: ${(props) => props.pad};
  border-radius: ${(props) => props.radius};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NameDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
